import { HARVEST_GRAB_FRAME } from "odyssey-shared";
import type { PageMark } from "./marks.ts";

/**
 * What the page draws of the harvest in the prop being harvested (ADR-142's amendment of 2026-10-31): on each round of
 * the own character's loop, at the frame where the blow lands, the prop shakes and a few leaves fly from it. The
 * effect is the page's alone: it reads the loop's frame and the prop the hold names, and nothing is sent or kept.
 */

/**
 * How far the prop swings across, in world pixels, and how long the shake lasts, in milliseconds: a blow lasts under a quarter of
 * a second, so the shake is done before the next round's.
 */
export const HARVEST_SHAKE_PIXELS = 1;
export const HARVEST_SHAKE_MS = 160;

/**
 * What the effects ask of the canvas.
 */
export interface HarvestFxPort {
  readonly shake: (id: string) => void;
  readonly leaves: (x: number, y: number, feetY: number) => void;
}

/**
 * The page's harvest effects.
 */
export class HarvestFx {
  private blowing = false;

  /**
   * @param port What the effects ask of the canvas.
   * @param held The prop the running hold names, or null for none.
   */
  public constructor(
    private readonly port: HarvestFxPort,
    private readonly held: () => PageMark | null,
  ) {}

  /**
   * Looks at the frame of the loop the own character shows this frame; the first frame of each blow starts the effects.
   *
   * @param frame The harvest strip's frame, -1 while it does not show.
   */
  public step(frame: number): void {
    if (frame < HARVEST_GRAB_FRAME) {
      this.blowing = false;
      return;
    }
    if (this.blowing) {
      return;
    }
    this.blowing = true;
    const mark = this.held();
    if (mark === null) {
      return;
    }
    this.port.shake(mark.id);
    this.port.leaves((mark.left + mark.right) / 2, mark.top + Math.round((mark.bottom - mark.top) * 0.55), mark.bottom);
  }
}
